"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TimelinesHelpers_1 = require("./TimelinesHelpers");
var TickMark = function (props) {
    return (react_1.default.createElement("div", { className: "tick-mark" },
        react_1.default.createElement("div", { className: "marks", style: {
                width: "".concat(props.scale, "px"),
            } },
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null),
            react_1.default.createElement("div", null)),
        react_1.default.createElement("p", null, (0, TimelinesHelpers_1.convertTime)(parseInt(props.timeMark)))));
};
exports.default = TickMark;
